import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { TrackingService } from '../../servicios/tracking.service';

@Component({
  selector: 'app-servientrega',
  templateUrl: './servientrega.component.html',
  styleUrls: ['./servientrega.component.scss']
})
export class ServientregaComponent implements OnInit {

  detalle: boolean = true;
  historial: boolean = false;

  id: any;
  loading: boolean;

  dataEnvio;
  history;

  constructor(protected serviceService: TrackingService, private route: ActivatedRoute) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      //console.log('este es el id ' + params.get('id'));
      this.id = params.get('id');

      //BUSCADOR
      this.rastreador(this.id);
    });
  }

  rastreador(id: any): void {
    this.serviceService.getTrackServientrega(id).subscribe(data => {
      console.log(data)
      this.dataEnvio = data[0];
      if (this.dataEnvio.estado_general === '') {
        this.dataEnvio.estado_general = 'Indefinido';
      } else {
        this.history = data[0].historial;
        let hist = this.history.replace(/'/g, '"');
        let str1 = hist.slice(1, -1);
        let parts: any[] = str1.split('},{');
        let json: any[] = [];
        parts.forEach((ele: any, i) => {
          ele.slice(1, -1);
          json[i] = JSON.parse('{' + ele + '}');
        });
        json.forEach((ele: any, i) => {
          json[i].Hora = ele.Hora.slice(0, -3);
        });
        this.history = json;
      }
      // console.log(this.history);
      this.loading = false;
    }, (error) => {
      // console.error(error.status)
      setTimeout(function () {
        Swal.fire({
          title: 'Error!',
          text: 'Servidor no reconoce los datos',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        })
        if (error.status === 400) {
          // console.log(true)
        }
      }, 3000);
    });
  }


  detalleClick(): void {
    this.detalle = true;
    this.historial = false;
  }

  historialClick(): void {
    this.detalle = false;
    this.historial = true;
  }

}
